import { projectListingConfiguration } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveProjectListingConfigurationRequestFailure({ uuid }) {
      const req = getState().find(({ planzone }) => planzone.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isRetrieveProjectListingConfigurationRequestPending({ uuid }) {
      const req = getState().find(({ planzone }) => planzone.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isRetrieveProjectListingConfigurationRequestSuccess({ uuid }) {
      const req = getState().find(({ planzone }) => planzone.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
    getProjectListingConfiguration({ uuid }) {
      const req = getState().find(({ planzone }) => planzone.uuid === uuid);

      return req ? req.configuration : projectListingConfiguration;
    },
  };
}

export { createSelector };
